export default __webpack_public_path__ + "static/media/2.8ffcba3f.jpeg";